import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { AuthRequestBnbaccess } from './auth-request-bnbaccess.model';
import { AuthRequestBnbaccessService } from './auth-request-bnbaccess.service';

@Component({
    selector: 'jhi-auth-request-bnbaccess-detail',
    templateUrl: './auth-request-bnbaccess-detail.component.html'
})
export class AuthRequestBnbaccessDetailComponent implements OnInit, OnDestroy {

    authRequest: AuthRequestBnbaccess;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private authRequestService: AuthRequestBnbaccessService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['authRequest']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load (id) {
        this.authRequestService.find(id).subscribe(authRequest => {
            this.authRequest = authRequest;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/auth-request/auth-request-bnbaccess-detail.component.ts